import { render, staticRenderFns } from "./profile-default-message.vue?vue&type=template&id=1cb6f724&scoped=true&"
import script from "./profile-default-message.vue?vue&type=script&lang=js&"
export * from "./profile-default-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb6f724",
  null
  
)

export default component.exports